import React from 'react'
import TableLayout from '../../components/TableLayout'

const CheckoutsListContainer = () => {
    const columns = [
        {
            title: 'Código',
            dataIndex: 'code',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Nombre',
            dataIndex: 'name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Descripción',
            dataIndex: 'description',
            sorter: true,
            filtered: true,
        },

        {
            title: 'Sucursal',
            dataIndex: 'subsidiary.name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Versión',
            dataIndex: 'installed_version',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Instalación',
            dataIndex: 'installed_date',
            sorter: true,
            filtered: true,
            dataType: 'date',
        },
        {
            title: 'Creación',
            dataIndex: 'created_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Actualizacíón',
            dataIndex: 'updated_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
        },
    ]

    return (
        <>
            <TableLayout
                title="Listado de cajas"
                columns={columns}
                resource="checkouts"
                actions={['excel','pdf', 'active', 'create', 'edit', 'show']}
            />
        </>
    )
}

export default CheckoutsListContainer
